import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { UserProfileService } from '@threshold/services';

@Directive({
  selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit {
  @Input() featureFlag: string[];
  @Input() featureFlagElse?: TemplateRef<any>; // Allow an optional "else" template

  constructor(
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private userProfileService: UserProfileService
  ) { 
  }
  ngOnInit(){
        if (this.userProfileService.getFeatureFlagsFromLocalStorage() !== null && !this.userProfileService.haveFlagsExpired(59)) {
          this.renderView(); 
        } else {
          this.userProfileService.setFeatureFlagsConfig().subscribe(() => {
            this.renderView();
          })
        }
  }

  renderView() {
    const localStorageFlags = JSON.parse(this.userProfileService.getFeatureFlagsFromLocalStorage());
    const noFeatureFlagMatch = this.featureFlag.every(flag => localStorageFlags.indexOf(flag) === -1);

    this.vcr.clear(); // Clear existing view first

    if (noFeatureFlagMatch) {
      this.vcr.createEmbeddedView(this.tpl);
    } else {
      this.vcr.createEmbeddedView(this.featureFlagElse);
    }
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/feature-flag/feature-flag.directive.ts